var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "date-picker-settings" } }, [
    _c("div", { staticClass: "form-field" }, [
      _c(
        "label",
        { staticClass: "form-label", attrs: { for: "field-label" } },
        [_vm._v(_vm._s(_vm.$t("form.fieldLabel")))]
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.item.datePicker.fieldLabel,
            expression: "item.datePicker.fieldLabel",
          },
        ],
        staticClass: "form-input",
        attrs: {
          type: "text",
          id: "field-label",
          placeholder: _vm.$t("message.date"),
        },
        domProps: { value: _vm.item.datePicker.fieldLabel },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.item.datePicker, "fieldLabel", $event.target.value)
            },
            function ($event) {
              return _vm.setFieldLabel(_vm.item.datePicker.fieldLabel)
            },
          ],
        },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-field" }, [
      _c("label", { staticClass: "form-label" }, [
        _vm._v(_vm._s(_vm.$t("form.labelAlignment"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "button-group" }, [
        _c(
          "button",
          {
            staticClass: "button",
            class: { active: _vm.align === "left" },
            on: {
              click: function ($event) {
                return _vm.setLabelAlign("left")
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("form.left")))]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "button",
            class: { active: _vm.align === "right" },
            on: {
              click: function ($event) {
                return _vm.setLabelAlign("right")
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("form.right")) + "\n            ")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "button",
            class: { active: _vm.align === "top" },
            on: {
              click: function ($event) {
                return _vm.setLabelAlign("top")
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("form.top")))]
        ),
      ]),
      _vm._v(" "),
      _c("small", { staticClass: "form-description" }, [
        _vm._v(_vm._s(_vm.$t("form.chooseLabelAlignment"))),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-field" }, [
      _c("label", { staticClass: "form-label" }, [
        _vm._v(_vm._s(_vm.$t("form.required"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "toggle" }, [
        _c(
          "span",
          {
            staticClass: "toggle-option",
            class: { active: _vm.isRequired },
            on: { click: _vm.toggleRequired },
          },
          [_vm._v(_vm._s(_vm.requiredText))]
        ),
      ]),
      _vm._v(" "),
      _c("small", { staticClass: "form-description" }, [
        _vm._v(_vm._s(_vm.$t("form.fieldEmptyError"))),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-field" }, [
      _c("label", { staticClass: "form-label" }, [
        _vm._v(_vm._s(_vm.$t("form.subLabels"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "sub-labels" }, [
        _c("div", { staticClass: "sub-label-item" }, [
          _c(
            "label",
            { staticClass: "sub-label", attrs: { for: "date-label" } },
            [_vm._v(_vm._s(_vm.$t("message.date")))]
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.item.datePicker.dateLabel,
                expression: "item.datePicker.dateLabel",
              },
            ],
            staticClass: "sub-label-input",
            attrs: {
              type: "text",
              id: "date-label",
              placeholder: _vm.$t("message.date"),
            },
            domProps: { value: _vm.item.datePicker.dateLabel },
            on: {
              input: [
                function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.item.datePicker,
                    "dateLabel",
                    $event.target.value
                  )
                },
                function ($event) {
                  return _vm.setDateLabel(_vm.item.datePicker.dateLabel)
                },
              ],
            },
          }),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }